import './styles.scss';
import { useContext, useEffect, useMemo, useState } from 'react';

import { AnimatedTransition } from '../../../components/animated-transition';
import { PORTFOLIO_TABS_NAME } from '../../../constants/reports/reports-data';
import { GlobalContext } from '../../../providers/global-provider';
import { riskTypes } from '../../../providers/risk-management/risk-management-provider';
import { IAccountOption } from '../../../providers/venue-provider';
import { LegacyPnl, Pnl, Positions, RiskManagement, StrikeReport, Transactions } from '../pages';

import { PortfolioTabsBase } from './portfolio-tabs-base';

interface PortfolioTabsProps {
  accountOption: IAccountOption;
}

export const PortfolioTabs = ({ accountOption }: PortfolioTabsProps) => {
  const { portfolioCurrentTab } = useContext(GlobalContext);
  const [tabs, setTabs] = useState<any>({});

  useEffect(() => {
    setTabs({
      [PORTFOLIO_TABS_NAME.spotLadder]: (
        <RiskManagement matrix={riskTypes.spotLadder} accountOption={accountOption} />
      ),
      [PORTFOLIO_TABS_NAME.spotGrid]: (
        <RiskManagement matrix={riskTypes.spotGrid} accountOption={accountOption} />
      ),
      [PORTFOLIO_TABS_NAME.spotTime]: (
        <RiskManagement matrix={riskTypes.spotTime} accountOption={accountOption} />
      ),
      [PORTFOLIO_TABS_NAME.pnlLegacy]: <LegacyPnl accountOption={accountOption} />,
      [PORTFOLIO_TABS_NAME.pnl]: <Pnl accountOption={accountOption} />,
      [PORTFOLIO_TABS_NAME.positionsAndOrders]: <Positions accountOption={accountOption} />,
      [PORTFOLIO_TABS_NAME.transactions]: <Transactions accountOption={accountOption} />,
      [PORTFOLIO_TABS_NAME.strikeReport]: <StrikeReport />,
    });
  }, [accountOption]);

  const renderTabs = useMemo(() => {
    return Object.keys(tabs).map((key) => {
      const isPortfolioCurrentTab = portfolioCurrentTab === key;

      return (
        <div key={key} className={`tabs-wrapper ${isPortfolioCurrentTab ? 'tab-visible' : ''}`}>
          {tabs[key]}
        </div>
      );
    });
  }, [tabs, portfolioCurrentTab]);

  return (
    <div className="portfolio-tabs-container">
      <AnimatedTransition>
        <PortfolioTabsBase />
        <AnimatedTransition>{renderTabs}</AnimatedTransition>
      </AnimatedTransition>
    </div>
  );
};
